export default {
	title: 'Informe de Revisión de Equipo',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elemento(s) seleccionado(s)',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	sendEmail: 'Enviar Correo',
	sendEmailWithCount: 'Enviar Correo ({count})',
	noData: {
		title: 'Sin Informes de Revisión de Equipo',
		description: 'No se encontraron datos relevantes del informe de revisión de equipo'
	},
	reportCard: {
		coverAlt: 'Portada del Informe de Revisión de Equipo',
		author: 'Autor',
		approver: 'Aprobador',
		updateTime: 'Tiempo de Actualización'
	},
	actions: {
		add: 'Agregar',
		generateReport: 'Generar Informe',
		download: 'Descargar',
		modify: 'Modificar',
		delete: 'Eliminar',
		sendEmail: 'Enviar Correo',
		batchDelete: 'Eliminar en Lote'
	},
	emailDialog: {
		title: 'Enviar Correo',
		ccPerson: 'Persona CC',
		selectCcPerson: 'Por favor seleccione la persona CC',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		selectReportWarning: 'Por favor seleccione informe de revisión de equipo',
		selectCcPersonWarning: 'Por favor seleccione la persona CC',
		sendSuccess: 'Enviado exitosamente',
		deleteConfirm: '¿Está seguro de eliminar los {count} elementos seleccionados?',
		deleteSuccess: 'Eliminado exitosamente',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		generateReportSuccess: 'Informe generado exitosamente',
		operateSuccess: 'Operación exitosa',
		selectedCount: '{count} elemento(s) seleccionado(s)'
	},
	form: {
		fileName: 'Nombre del Informe',
		startTime: 'Tiempo de Inicio',
		endTime: 'Tiempo de Fin',
		reportTitle: 'Título del Informe',
		author: 'Autor',
		approver: 'Aprobador',
		orgId: 'Departamento',
		result: 'Resultado del Diagnóstico',
		fileViewInDoc: 'Ver en documento',
		equipmentCheckReport: 'Informe de Revisión de Equipo',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		add: 'Agregar',
		update: 'Actualizar',
		deviceName: 'Nombre del Dispositivo',
		deviceParams: 'Parámetros del Dispositivo',
		paramName: 'Nombre del Parámetro',
		paramValue: 'Valor del Parámetro',
		addParam: 'Agregar Parámetro',
		reviewer: 'Revisor',
		diagnosis: 'Análisis de Diagnóstico',
		advice: 'Consejo de Mantenimiento',
		sensorPicPath: 'Esquema del Sensor',
		vibrationData: 'Datos de Monitoreo de Condición',
		sensorName: 'Nombre del Sensor',
		vibrationH: 'Velocidad de Vibración Horizontal mm/s',
		vibrationV: 'Velocidad de Vibración Vertical mm/s',
		vibrationA: 'Velocidad de Vibración Axial mm/s',
		vibrationAcc: 'Aceleración de Vibración m/s²',
		addSensorData: 'Agregar Datos del Sensor',
		attachment: 'Carga de Archivos Adjuntos',
		uploadFile: 'Cargar Archivo',
		picturePreview: 'Imagen de Vista Previa'
	},
	table: {
		reportTitle: 'Título del Informe',
		equipmentCheckReport: 'Informe de Revisión de Equipo',
		author: 'Autor',
		approver: 'Aprobador',
		orgId: 'Departamento',
		result: 'Resultado del Diagnóstico',
		updateTime: 'Tiempo de Diagnóstico'
	}
}
